// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_xHDHR {
  z-index: 999;
  position: absolute;
}

.bg_cSEan { 
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.newContactContainer_eizDx {
  position: fixed;
  top: 50%;
  left: 50%;
  background-color: var(--white-background);
  z-index: 9999;
}
.popupNewContaier_m27ql{
  display: flex;
  width: 100%;
  .leftSide_Fnbhz{
    height: 100%;
    width: 100%;
    max-width: 250px;
    min-width: 240px;
    
    @media (width<=768px) {
      max-width: 80%;
      display:none;
    }
  }
  @media (width<=768px) {
    flex-direction: column;
    align-items: center;
  }
}
.container_ANOTU {
  padding: 20px;
  min-height: 100vh;
}

.inputWrapper_HkI_w {
  position: relative;
  display: flex;
  align-items: center;
  height: 40px;
  border-radius: 0 10px 10px 0;
  .searchInput_GndFY {
    padding: 10px 10px 10px 35px;
    border: 1px solid var(--ccc-border);
    border-radius: 10px;
    font-size: 16px;
    outline: none;
    width: 250px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    &::placeholder {
      color: var(--aaa-color);
    }
  }
}





.addButton_aUdDN {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 40px;
  background-color: var(--_233f39-background);
  color: var(--white-background);
  border: none;
  cursor: pointer;
  font-size: 16px;
  border-radius: 13px;
  -webkit-border-radius: 13px;
  -moz-border-radius: 13px;
  -ms-border-radius: 13px;
  -o-border-radius: 13px;
  img {
    width: 15px;
    height: 15px;
  }
}
.addButton_aUdDN:hover {
  background-color: var(--_122521-background);
}

.table_N_b2S {
  width: 100%;
  text-align: start;
  border-collapse: collapse; 
  tbody {
    p {
      margin: 0;
    }
    th {
      text-align: start;
      padding: 10px;
      color: var(--_3-color); 
      font-weight: bold; 
      width: 150px; 
    }

    td {
      padding: 10px; 
      color: var(--_6-color);
      font-size: 13px;
      p:first-of-type {
        margin-bottom: 10px;
      }
    }
  }

  thead {
    th {
      min-width: 120px; 
    }
  }

}

.name_zzlgG {
  color: var(--_3-color);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  img {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    -ms-border-radius: 100%;
    -o-border-radius: 100%;
  }
}

.small__YMic {
  min-width: 40px;
  width: 40px;
}
.big_kEFcT {
  width: 190px;
}

.actions_HDAjd {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  height: 35px;
  img {
    cursor: pointer;
  }
}

.transacciones_XgbuC {
  display: flex;
  flex-direction: column;
  gap: 3px;
  a {
    font-weight: bold;
  }
  a,
  span {
    color: var(--_073f31-color);
  }
}

input[type="checkbox"] {
  width: 15px;
  height: 15px;
}

.bg_cSEan {
  background-color: var(--_00000020-background);
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
}

.newContactContainer_eizDx {
  position: fixed;
  background-color: var(--white-background);
  padding-bottom: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height:100vh;
  width:100%;
  overflow-y: scroll;
  border-radius: 10px;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;

  &::-webkit-scrollbar {
    display: none;
  }

  .newContactForm_Lb0BA {
    width: 90%;
    margin: 0 auto;
  }





  .row_Fm5It {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  p {
    color: var(--black-color);
    font-weight: 500;
    margin: 0;
    font-size: 14px;
  }
  .plan_JHYer {
    padding-right: 30px;
    span {
      color: var(--black-color);
    }
  }

  .inputContainer_ObXEW {
    position: relative;
    display: flex;
    align-items: center;
  }
  .input_IR1es {
    width: 100%;
    padding-right: 40px; 
    box-sizing: border-box; 
  }

  .icon_vrqFV {
    position: absolute;
    right: 10px; 
    top: 50%;
    transform: translateY(-50%);
    width: 30px; 
    height: 20px;
    pointer-events: none; 
  }
  label,.phoneNumber_OSj8t {
    display: flex;
    flex-direction: column;
    color: var(--_71-color);
    gap: 8px;
    padding: 4px 0;
    input,
    select,
    option {
      padding: 8px;
      border: none;
      outline: none;
      background-color: var(--f5-background);
      border-radius: 4px;
      -webkit-border-radius: 4px;
      -moz-border-radius: 4px;
      -ms-border-radius: 4px;
      -o-border-radius: 4px;
    }

    select,
    option {
      color: var(--_75-color);
    }
  }


  .btnOptionsContainer_WfFTg {
    display: flex;
    width: 100%;
    justify-content: end;
    align-items: center;
    gap: 10px;
    button {
      padding: 10px 20px;
      border-radius: 8px;
      text-decoration: none;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      -ms-border-radius: 8px;
      -o-border-radius: 8px;
    }


  }


}



.subHeader_rP4VW {
  color: var(--_71717a-color);
  font-size: 12px;
  font-weight: normal;
}

.table_N_b2S th {
  padding: 16px 8px;
  vertical-align: middle;
  color: var(--_48-color);

}

.edit_fJk3O {
  position: relative;
  display: flex;
  gap: 10px;
  align-items: end;
  a {
    color: var(--_073f31-color);
  }
}










.newContactContainer_eizDx {
  background-color: var(--white-background);
  padding-bottom: 20px;
  height:100vh;
  width:100%;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  animation: scaleUp_WiCsI 300ms ease-out forwards;
  -webkit-animation: scaleUp_WiCsI 300ms ease-out forwards;
  &::-webkit-scrollbar {
    display: none;
  }

.newContactForm_Lb0BA {
    width: 90%;
    margin: 0 auto;
    height: 100vh;
    overflow: scroll;
    padding-bottom: 100px;
    box-sizing: border-box;
    &::-webkit-scrollbar {
      display: none;
    }
  }


}
.sectionContact_yynvR{
  h3{
    color: var(--_10a37f-background);
    margin: 20px 0;
  }
   h5{
    color: var(--_10a37f-background);
    margin: 20px 0;
  }

  .infoLabel_K53bM,.infoLabelIdentification_P3JKp{
    background-color: var(--white-background);
    padding: 10px 20px;
    border: 1px solid var(--ececf1-border);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 50px;
    >div{

    }
  }
  .infoLabelIdentification_P3JKp{
    gap: 10px;
  }
}


.containerNewContactForm_1Grx1 {
  width: 100%;
  margin: 0 auto;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
}
.typeContact_BXLz_ {
  display: flex;
  background-color: var(--f3-background);
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  padding: 6px;
  gap: 10px;
  width: 100%;
  height: fit-content;
  box-sizing: border-box;
  overflow-x: auto;


  button {
    background-color: transparent;
    cursor: pointer;
    color: var(--_9-color);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    border: 1px solid transparent !important;
    flex: 1 1;
    background-color: transparent;
    max-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    outline: none;
}
  .selected_TTPmL {
    background-color: var(--white-background);
    color: var(--_0d-color);
    border-radius: 8px;
    border: 1px solid var(--_0000002b-border) !important;
    box-shadow:
      0px 0px 2px 0px var(--_00000008-shadow),
      0px 0px 0px 0px var(--_00000000-shadow),
      0px 0px 0px 0px var(--_00000000-shadow);
  }
}



.button_WcZ7w {
  cursor: pointer;
  background-color: transparent;
  text-decoration: underline;
  font-weight: 600;
  color: var(--_18181b-color);
  font-size: 14px;
}

.newContactForm_Lb0BA {
  label {
    padding: 10px 0;
    p {
      color: var(--_1d-color);
      font-weight: 400;
    }
  }
  .detailsBill_aTHU9 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .optionsDetailsBill_InNAN {
      display: flex;
      align-items: center;
      gap: 10px;
      text-align: end;
    }
  }

  .payMethodInfoBill_kLvvx{
   .infoBillContainer_TLswX{
    border-bottom: 1px solid var(--11a38138-border);
    padding: 10px 0;
   }
  }
  .infoBillContainer_TLswX {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .info_ZMw6i{
      p{
        width: 100%;
        display: flex;
        align-items: center;
        svg{
          margin-right: 5px;
        }
      }
    }
  }
  .editPencilContainer_QSB3c{
    border: 1px solid var(--cb-border);
    height: 30px;
    min-width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    cursor: pointer;
  }
  .billingDetailsContainer_btxGx{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-bottom: 1px solid var(--11a38138-border);
    padding: 10px 0;
    &:last-child{

    }
  }
  .infoBill_DiMCm {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 5px;
    span {
      color: var(--_71-color);
    }
    .defaultAddress_VliGx {
      display: flex;
      width: 100%;
      justify-content: end;
      align-items: center;
      span {
        color: var(--_2ebc89-color);
      }
    }
    .infoBillContainer_TLswX {
      width: 100%;
      display: flex;
      align-items: center;


      .info_ZMw6i {
        flex-direction: column;
        align-items: start;
        p{
          display: flex;
          align-items: center;
          svg{
            margin-right: 5px;
          }
        }
      }
    }
    .info_ZMw6i {
      display: flex;
      width: 100%;
      span {
        width: fit-content;
        color: var(--_71-color);
        font-weight: 400;
      }
    }
    .button_WcZ7w {
      width: fit-content;
      background-color: transparent;
      outline: none;
      border: none;
      text-decoration: underline;
      cursor: pointer;
      padding: 0;
    }
  }

  .info_ZMw6i {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 19px;

    span {
      color: var(--_71-color);
      font-weight: 400;
    }
  }

  .row_Fm5It {
    display: flex;
    gap: 10px;
    .info_ZMw6i {
      flex: 1 1;
    }
  }

  button[disabled],
  input[disabled],
  select[disabled],
  option[disabled],
  textarea[disabled] {
    background-color: transparent;
  }


  input,
  select,
  option,
  textarea {
    border: none;
    outline: none;
    background-color: var(--f4-background);
    padding: 12px;
    box-sizing: border-box;
  }
  button::placeholder,
  input::placeholder,
  select::placeholder,
  option::placeholder,
  textarea::placeholder {
    color: var(--_75-color);
  }

  input {
    width: 100%;

    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
  }
  input[type="checkbox"] {
    width: fit-content;
  }

  .payMethodContainer_nbi4q {
    display: flex;
    gap: 10px;
    flex-direction: column;
    border: 1px solid var(--_11a3812c-border);
    color: var(--_1e0045-color);
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -ms-border-radius: 4px;
    -o-border-radius: 4px;
    span {
      font-weight: 600;
    }
  }

  .payInfo_fDQuf {
    display: flex;
    gap: 10px;
  }

  .defaultBank_sg9zh {
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 20px;
    gap: 30px;
    div {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    p {
      margin: 0;
      color: var(--_2ebc89-color);
    }
    input {
      width: fit-content;
    }
  }
  .delete_oPa0T {
    background-color: var(--dc3545-background);
    height: 20px;
    min-width: 20px;
    max-width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    cursor: pointer;
    .icon_vrqFV {
      height: 13px;
      width: 13px;
    }
  }
.contactinfo_lAAcy{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  @media (width<=768px) {
    flex-direction: column;
    align-items: center;
  }
.fileInfo_d646b{
  display: flex;
  align-items: center;
  justify-content: end;
  input{
    background-color: var(--white-background);
    width: 100%;
    font-size: 20px;
    padding: 8px;
    &:disabled{
      background-color: transparent;
    }
  }

}

  .columnRightContactInfo_E9Pri{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: end;
    overflow: hidden;
    gap: 10px;
    padding-left: 20px;
    @media (width<=768px) {
      align-items: center;

    }

    .btnContactInfoContainer_ahjvs{
      display: flex;
      align-items: center;
      gap: 5px;
      button{
        svg{
          color: var(--969595-fill);
          fill: var(--969595-fill);
        }
        .activeBtn_OKy65{
          color: var(--_10a37f-border);
          fill: var(--_10a37f-border);
        }
      }
      svg{
        width: 20px;
        height: 20px;
      }
    }
.tagsContainer_WjGGs{
display: flex;
align-items: center;
gap: 10px;
width: 100%;
overflow-x: auto;
  .tag__ziDP{
    display: flex;
    align-items: center;
    gap: 5px;
    span{
      min-width: 60px;
    }
  }
}
  }

}

  .parametersCounter_X44ty {
    margin: 10px 0;
    display: flex;
    align-items: center;
    gap: 5px;
    .icon_vrqFV {
      height: 10px;
      width: 10px;
      -webkit-transition: all 300ms;
      transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -o-transform: rotate(0deg);
    }
    .rotated_hf8C4 {
      transform: rotate(180deg);
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
      -o-transform: rotate(180deg);
    }
  }

  .parameter_eQP_z {
    display: flex;
    gap: 10px;
    div {
      flex: 1 1;
    }
  }
  .parametersContainer_Kmzlt {
    transition: all 300ms;
    -webkit-transition: all 300ms;
    -moz-transition: all 300ms;
    -ms-transition: all 300ms;
    -o-transition: all 300ms;
    overflow: hidden;
    interpolate-size: allow-keywords;
  }
}

.defaultPhoneNumber_p_oYG{
  width: 100%;
  color: var(--_10a37f-background);
  display: flex;
  align-items: center;
  gap: 5px;
}
.headerPhoneNumer_XwFY_ {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

.headerPhoneNumerPopup_u9E_c{
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  p{
    font-size: 12px;
    margin: 0;
  }
}

.headerPhoneNumerPopupLeft_J_64M {
  display: flex;
  flex-direction: column;

  .headerPhoneNumerPopupLeftFirstLine_Y3aGL{
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: start;
  }

  .headerPhoneNumerPopupLeftSecondLine_z8pop{
    display: flex;
    align-items: center;
    gap: 10px;
  }
}
.unknown_TVA9x {
  font-size: 14px;
  font-weight: 400;
  color: var(--_71-color);
}
.phoneNumber_OSj8t {
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 10px;
}
.buttonPhoneContainer_SfPOR {
  display: flex;
  align-items: center;
  gap: 10px;
}
.phoneContainerUnknown_qKD5H {
  display: flex;
  width: 100%;
}
.phoneContainer__k8JC {
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: center;
  flex-direction: column;
  .phoneRow_aQ5V0 {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;

      svg{
        height: 20px;
        width: 20px;
      }
  }
  .delete_oPa0T {
    background-color: var(--dc3545-background);
    height: 20px;
    min-width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    -ms-border-radius: 50%;
    -o-border-radius: 50%;
    cursor: pointer;
    .icon_vrqFV {
      height: 13px;
      width: 13px;
    }
  }
}

.searchIconsWrappers_KkgS2 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}
.FlagsDropdown_lBMVh {
  min-width: 150px;
}

.deleteButtonContainer_j5Nak{
padding-left: 5px;
display: none;
}

.categoryButton_Vg1US{

}


.categoryButton_Vg1US:hover{
  .deleteButtonContainer_j5Nak{
display: block;
}

}
.inputPhonePopup_lF3P7::-webkit-outer-spin-button,
.inputPhonePopup_lF3P7::-webkit-inner-spin-button {
-webkit-appearance: none;
margin: 0;
}
.inputPhonePopup_lF3P7 {
  -moz-appearance: textfield;
  margin: 0;
  padding: 3px 2px;
}

.sectionContactPopup_qT6Pz{
    h3{
    color: var(--_10a37f-background);
    margin: 20px 0;
  }
   h5{
    color: var(--_10a37f-background);
    margin: 20px 0;
  }

  .infoLabel_K53bM,.infoLabelIdentification_P3JKp{
    background-color: var(--white-background);
    padding: 10px 20px;
    border: 1px solid var(--ececf1-border);
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 50px;
    >div{

    }
  }
  .infoLabelIdentification_P3JKp{
    gap: 10px;
  }

  p{
    font-size: 12px;
  }

  span{
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NewContact/NewContact.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,yCAAyC;EACzC,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,gBAAgB;;IAEhB;MACE,cAAc;MACd,YAAY;IACd;EACF;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,4BAA4B;EAC5B;IACE,4BAA4B;IAC5B,mCAAmC;IACnC,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB;MACE,uBAAuB;IACzB;EACF;AACF;;;;;;AAMA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,2CAA2C;EAC3C,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB;IACE;MACE,SAAS;IACX;IACA;MACE,iBAAiB;MACjB,aAAa;MACb,sBAAsB;MACtB,iBAAiB;MACjB,YAAY;IACd;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,eAAe;MACf;QACE,mBAAmB;MACrB;IACF;EACF;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;;AAEF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;IACE,iBAAiB;EACnB;EACA;;IAEE,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,qCAAqC;EACrC,oCAAoC;EACpC,mCAAmC;EACnC,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;;EAEtB;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;;;;;EAMA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,SAAS;IACT,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd;;;MAGE,YAAY;MACZ,YAAY;MACZ,aAAa;MACb,sCAAsC;MACtC,kBAAkB;MAClB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;IACvB;;IAEA;;MAEE,uBAAuB;IACzB;EACF;;;EAGA;IACE,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT;MACE,kBAAkB;MAClB,kBAAkB;MAClB,qBAAqB;MACrB,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,qBAAqB;IACvB;;;EAGF;;;AAGF;;;;AAIA;EACE,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;;AAEzB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB;IACE,2BAA2B;EAC7B;AACF;;;;;;;;;;;AAWA;EACE,yCAAyC;EACzC,oBAAoB;EACpB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,gDAA0C;EAC1C,wDAAkD;EAClD;IACE,aAAa;EACf;;AAEF;IACI,UAAU;IACV,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB;MACE,aAAa;IACf;EACF;;;AAGF;AACA;EACE;IACE,gCAAgC;IAChC,cAAc;EAChB;GACC;IACC,gCAAgC;IAChC,cAAc;EAChB;;EAEA;IACE,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT;;IAEA;EACF;EACA;IACE,SAAS;EACX;AACF;;;AAGA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;;;EAGhB;IACE,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,wCAAwC;IACxC,SAAO;IACP,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;EACE;IACE,yCAAyC;IACzC,uBAAuB;IACvB,kBAAkB;IAClB,oDAAoD;IACpD;;;6CAGyC;EAC3C;AACF;;;;AAIA;EACE,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf;MACE,uBAAuB;MACvB,gBAAgB;IAClB;EACF;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;;IAEnB;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,eAAe;IACjB;EACF;;EAEA;GACC;IACC,+CAA+C;IAC/C,eAAe;GAChB;EACD;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET;MACE;QACE,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB;UACE,iBAAiB;QACnB;MACF;IACF;EACF;EACA;IACE,kCAAkC;IAClC,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,+CAA+C;IAC/C,eAAe;IACf;;IAEA;EACF;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR;MACE,uBAAuB;IACzB;IACA;MACE,aAAa;MACb,WAAW;MACX,oBAAoB;MACpB,mBAAmB;MACnB;QACE,2BAA2B;MAC7B;IACF;IACA;MACE,WAAW;MACX,aAAa;MACb,mBAAmB;;;MAGnB;QACE,sBAAsB;QACtB,kBAAkB;QAClB;UACE,aAAa;UACb,mBAAmB;UACnB;YACE,iBAAiB;UACnB;QACF;MACF;IACF;IACA;MACE,aAAa;MACb,WAAW;MACX;QACE,kBAAkB;QAClB,uBAAuB;QACvB,gBAAgB;MAClB;IACF;IACA;MACE,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,YAAY;MACZ,0BAA0B;MAC1B,eAAe;MACf,UAAU;IACZ;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;;IAET;MACE,uBAAuB;MACvB,gBAAgB;IAClB;EACF;;EAEA;IACE,aAAa;IACb,SAAS;IACT;MACE,SAAO;IACT;EACF;;EAEA;;;;;IAKE,6BAA6B;EAC/B;;;EAGA;;;;IAIE,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,aAAa;IACb,sBAAsB;EACxB;EACA;;;;;IAKE,uBAAuB;EACzB;;EAEA;IACE,WAAW;;IAEX,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,yCAAyC;IACzC,2BAA2B;IAC3B,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;IACA;MACE,SAAS;MACT,2BAA2B;IAC7B;IACA;MACE,kBAAkB;IACpB;EACF;EACA;IACE,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf;MACE,YAAY;MACZ,WAAW;IACb;EACF;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB;IACE,yCAAyC;IACzC,WAAW;IACX,eAAe;IACf,YAAY;IACZ;MACE,6BAA6B;IAC/B;EACF;;AAEF;;EAEE;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB;MACE,mBAAmB;;IAErB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR;QACE;UACE,yBAAyB;UACzB,wBAAwB;QAC1B;QACA;UACE,4BAA4B;UAC5B,2BAA2B;QAC7B;MACF;MACA;QACE,WAAW;QACX,YAAY;MACd;IACF;AACJ;AACA,aAAa;AACb,mBAAmB;AACnB,SAAS;AACT,WAAW;AACX,gBAAgB;EACd;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR;MACE,eAAe;IACjB;EACF;AACF;EACE;;AAEF;;EAEE;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR;MACE,YAAY;MACZ,WAAW;MACX,6BAA6B;MAC7B,uBAAuB;MACvB,+BAA+B;MAC/B,4BAA4B;MAC5B,2BAA2B;MAC3B,0BAA0B;IAC5B;IACA;MACE,yBAAyB;MACzB,iCAAiC;MACjC,8BAA8B;MAC9B,6BAA6B;MAC7B,4BAA4B;IAC9B;EACF;;EAEA;IACE,aAAa;IACb,SAAS;IACT;MACE,SAAO;IACT;EACF;EACA;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;IAChB,gCAAgC;EAClC;AACF;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B;IACE,eAAe;IACf,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;;EAEtB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;AACF;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;;MAEP;QACE,YAAY;QACZ,WAAW;MACb;EACJ;EACA;IACE,0CAA0C;IAC1C,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf;MACE,YAAY;MACZ,WAAW;IACb;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;AACA,iBAAiB;AACjB,aAAa;AACb;;AAEA;;AAEA;;;AAGA;EACE;AACF,cAAc;AACd;;AAEA;AACA;;AAEA,wBAAwB;AACxB,SAAS;AACT;AACA;EACE,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;IACI;IACA,gCAAgC;IAChC,cAAc;EAChB;GACC;IACC,gCAAgC;IAChC,cAAc;EAChB;;EAEA;IACE,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT;;IAEA;EACF;EACA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".overlay {\n  z-index: 999;\n  position: absolute;\n}\n\n.bg { \n  height: 100vh;\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n}\n\n.newContactContainer {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  background-color: var(--white-background);\n  z-index: 9999;\n}\n.popupNewContaier{\n  display: flex;\n  width: 100%;\n  .leftSide{\n    height: 100%;\n    width: 100%;\n    max-width: 250px;\n    min-width: 240px;\n    \n    @media (width<=768px) {\n      max-width: 80%;\n      display:none;\n    }\n  }\n  @media (width<=768px) {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n.container {\n  padding: 20px;\n  min-height: 100vh;\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 40px;\n  border-radius: 0 10px 10px 0;\n  .searchInput {\n    padding: 10px 10px 10px 35px;\n    border: 1px solid var(--ccc-border);\n    border-radius: 10px;\n    font-size: 16px;\n    outline: none;\n    width: 250px;\n    -webkit-border-radius: 10px;\n    -moz-border-radius: 10px;\n    -ms-border-radius: 10px;\n    -o-border-radius: 10px;\n    &::placeholder {\n      color: var(--aaa-color);\n    }\n  }\n}\n\n\n\n\n\n.addButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  height: 40px;\n  background-color: var(--_233f39-background);\n  color: var(--white-background);\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n  border-radius: 13px;\n  -webkit-border-radius: 13px;\n  -moz-border-radius: 13px;\n  -ms-border-radius: 13px;\n  -o-border-radius: 13px;\n  img {\n    width: 15px;\n    height: 15px;\n  }\n}\n.addButton:hover {\n  background-color: var(--_122521-background);\n}\n\n.table {\n  width: 100%;\n  text-align: start;\n  border-collapse: collapse; \n  tbody {\n    p {\n      margin: 0;\n    }\n    th {\n      text-align: start;\n      padding: 10px;\n      color: var(--_3-color); \n      font-weight: bold; \n      width: 150px; \n    }\n\n    td {\n      padding: 10px; \n      color: var(--_6-color);\n      font-size: 13px;\n      p:first-of-type {\n        margin-bottom: 10px;\n      }\n    }\n  }\n\n  thead {\n    th {\n      min-width: 120px; \n    }\n  }\n\n}\n\n.name {\n  color: var(--_3-color);\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  img {\n    width: 30px;\n    height: 30px;\n    border-radius: 100%;\n    -webkit-border-radius: 100%;\n    -moz-border-radius: 100%;\n    -ms-border-radius: 100%;\n    -o-border-radius: 100%;\n  }\n}\n\n.small {\n  min-width: 40px;\n  width: 40px;\n}\n.big {\n  width: 190px;\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  height: 35px;\n  img {\n    cursor: pointer;\n  }\n}\n\n.transacciones {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  a {\n    font-weight: bold;\n  }\n  a,\n  span {\n    color: var(--_073f31-color);\n  }\n}\n\ninput[type=\"checkbox\"] {\n  width: 15px;\n  height: 15px;\n}\n\n.bg {\n  background-color: var(--_00000020-background);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n}\n\n.newContactContainer {\n  position: fixed;\n  background-color: var(--white-background);\n  padding-bottom: 20px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  height:100vh;\n  width:100%;\n  overflow-y: scroll;\n  border-radius: 10px;\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  .newContactForm {\n    width: 90%;\n    margin: 0 auto;\n  }\n\n\n\n\n\n  .row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  p {\n    color: var(--black-color);\n    font-weight: 500;\n    margin: 0;\n    font-size: 14px;\n  }\n  .plan {\n    padding-right: 30px;\n    span {\n      color: var(--black-color);\n    }\n  }\n\n  .inputContainer {\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n  .input {\n    width: 100%;\n    padding-right: 40px; \n    box-sizing: border-box; \n  }\n\n  .icon {\n    position: absolute;\n    right: 10px; \n    top: 50%;\n    transform: translateY(-50%);\n    width: 30px; \n    height: 20px;\n    pointer-events: none; \n  }\n  label,.phoneNumber {\n    display: flex;\n    flex-direction: column;\n    color: var(--_71-color);\n    gap: 8px;\n    padding: 4px 0;\n    input,\n    select,\n    option {\n      padding: 8px;\n      border: none;\n      outline: none;\n      background-color: var(--f5-background);\n      border-radius: 4px;\n      -webkit-border-radius: 4px;\n      -moz-border-radius: 4px;\n      -ms-border-radius: 4px;\n      -o-border-radius: 4px;\n    }\n\n    select,\n    option {\n      color: var(--_75-color);\n    }\n  }\n\n\n  .btnOptionsContainer {\n    display: flex;\n    width: 100%;\n    justify-content: end;\n    align-items: center;\n    gap: 10px;\n    button {\n      padding: 10px 20px;\n      border-radius: 8px;\n      text-decoration: none;\n      -webkit-border-radius: 8px;\n      -moz-border-radius: 8px;\n      -ms-border-radius: 8px;\n      -o-border-radius: 8px;\n    }\n\n\n  }\n\n\n}\n\n\n\n.subHeader {\n  color: var(--_71717a-color);\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.table th {\n  padding: 16px 8px;\n  vertical-align: middle;\n  color: var(--_48-color);\n\n}\n\n.edit {\n  position: relative;\n  display: flex;\n  gap: 10px;\n  align-items: end;\n  a {\n    color: var(--_073f31-color);\n  }\n}\n\n\n\n\n\n\n\n\n\n\n.newContactContainer {\n  background-color: var(--white-background);\n  padding-bottom: 20px;\n  height:100vh;\n  width:100%;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  animation: scaleUp 300ms ease-out forwards;\n  -webkit-animation: scaleUp 300ms ease-out forwards;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n.newContactForm {\n    width: 90%;\n    margin: 0 auto;\n    height: 100vh;\n    overflow: scroll;\n    padding-bottom: 100px;\n    box-sizing: border-box;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n\n}\n.sectionContact{\n  h3{\n    color: var(--_10a37f-background);\n    margin: 20px 0;\n  }\n   h5{\n    color: var(--_10a37f-background);\n    margin: 20px 0;\n  }\n\n  .infoLabel,.infoLabelIdentification{\n    background-color: var(--white-background);\n    padding: 10px 20px;\n    border: 1px solid var(--ececf1-border);\n    border-radius: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 50px;\n    >div{\n\n    }\n  }\n  .infoLabelIdentification{\n    gap: 10px;\n  }\n}\n\n\n.containerNewContactForm {\n  width: 100%;\n  margin: 0 auto;\n  padding: 10px;\n  box-sizing: border-box;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n}\n.typeContact {\n  display: flex;\n  background-color: var(--f3-background);\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  padding: 6px;\n  gap: 10px;\n  width: 100%;\n  height: fit-content;\n  box-sizing: border-box;\n  overflow-x: auto;\n\n\n  button {\n    background-color: transparent;\n    cursor: pointer;\n    color: var(--_9-color);\n    font-family: Inter;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    border-radius: 8px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    border: 1px solid transparent !important;\n    flex: 1;\n    background-color: transparent;\n    max-height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 12px;\n    outline: none;\n}\n  .selected {\n    background-color: var(--white-background);\n    color: var(--_0d-color);\n    border-radius: 8px;\n    border: 1px solid var(--_0000002b-border) !important;\n    box-shadow:\n      0px 0px 2px 0px var(--_00000008-shadow),\n      0px 0px 0px 0px var(--_00000000-shadow),\n      0px 0px 0px 0px var(--_00000000-shadow);\n  }\n}\n\n\n\n.button {\n  cursor: pointer;\n  background-color: transparent;\n  text-decoration: underline;\n  font-weight: 600;\n  color: var(--_18181b-color);\n  font-size: 14px;\n}\n\n.newContactForm {\n  label {\n    padding: 10px 0;\n    p {\n      color: var(--_1d-color);\n      font-weight: 400;\n    }\n  }\n  .detailsBill {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n\n    .optionsDetailsBill {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      text-align: end;\n    }\n  }\n\n  .payMethodInfoBill{\n   .infoBillContainer{\n    border-bottom: 1px solid var(--11a38138-border);\n    padding: 10px 0;\n   }\n  }\n  .infoBillContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n\n    .info{\n      p{\n        width: 100%;\n        display: flex;\n        align-items: center;\n        svg{\n          margin-right: 5px;\n        }\n      }\n    }\n  }\n  .editPencilContainer{\n    border: 1px solid var(--cb-border);\n    height: 30px;\n    min-width: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 8px;\n    cursor: pointer;\n  }\n  .billingDetailsContainer{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    border-bottom: 1px solid var(--11a38138-border);\n    padding: 10px 0;\n    &:last-child{\n\n    }\n  }\n  .infoBill {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    gap: 5px;\n    span {\n      color: var(--_71-color);\n    }\n    .defaultAddress {\n      display: flex;\n      width: 100%;\n      justify-content: end;\n      align-items: center;\n      span {\n        color: var(--_2ebc89-color);\n      }\n    }\n    .infoBillContainer {\n      width: 100%;\n      display: flex;\n      align-items: center;\n\n\n      .info {\n        flex-direction: column;\n        align-items: start;\n        p{\n          display: flex;\n          align-items: center;\n          svg{\n            margin-right: 5px;\n          }\n        }\n      }\n    }\n    .info {\n      display: flex;\n      width: 100%;\n      span {\n        width: fit-content;\n        color: var(--_71-color);\n        font-weight: 400;\n      }\n    }\n    .button {\n      width: fit-content;\n      background-color: transparent;\n      outline: none;\n      border: none;\n      text-decoration: underline;\n      cursor: pointer;\n      padding: 0;\n    }\n  }\n\n  .info {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 19px;\n\n    span {\n      color: var(--_71-color);\n      font-weight: 400;\n    }\n  }\n\n  .row {\n    display: flex;\n    gap: 10px;\n    .info {\n      flex: 1;\n    }\n  }\n\n  button[disabled],\n  input[disabled],\n  select[disabled],\n  option[disabled],\n  textarea[disabled] {\n    background-color: transparent;\n  }\n\n\n  input,\n  select,\n  option,\n  textarea {\n    border: none;\n    outline: none;\n    background-color: var(--f4-background);\n    padding: 12px;\n    box-sizing: border-box;\n  }\n  button::placeholder,\n  input::placeholder,\n  select::placeholder,\n  option::placeholder,\n  textarea::placeholder {\n    color: var(--_75-color);\n  }\n\n  input {\n    width: 100%;\n\n    border-radius: 4px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    -o-border-radius: 4px;\n  }\n  input[type=\"checkbox\"] {\n    width: fit-content;\n  }\n\n  .payMethodContainer {\n    display: flex;\n    gap: 10px;\n    flex-direction: column;\n    border: 1px solid var(--_11a3812c-border);\n    color: var(--_1e0045-color);\n    border-radius: 4px;\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    -ms-border-radius: 4px;\n    -o-border-radius: 4px;\n    span {\n      font-weight: 600;\n    }\n  }\n\n  .payInfo {\n    display: flex;\n    gap: 10px;\n  }\n\n  .defaultBank {\n    display: flex;\n    justify-content: end;\n    align-items: center;\n    padding: 20px;\n    gap: 30px;\n    div {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n    p {\n      margin: 0;\n      color: var(--_2ebc89-color);\n    }\n    input {\n      width: fit-content;\n    }\n  }\n  .delete {\n    background-color: var(--dc3545-background);\n    height: 20px;\n    min-width: 20px;\n    max-width: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    cursor: pointer;\n    .icon {\n      height: 13px;\n      width: 13px;\n    }\n  }\n.contactinfo{\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n  @media (width<=768px) {\n    flex-direction: column;\n    align-items: center;\n  }\n.fileInfo{\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  input{\n    background-color: var(--white-background);\n    width: 100%;\n    font-size: 20px;\n    padding: 8px;\n    &:disabled{\n      background-color: transparent;\n    }\n  }\n\n}\n\n  .columnRightContactInfo{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n    overflow: hidden;\n    gap: 10px;\n    padding-left: 20px;\n    @media (width<=768px) {\n      align-items: center;\n\n    }\n\n    .btnContactInfoContainer{\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      button{\n        svg{\n          color: var(--969595-fill);\n          fill: var(--969595-fill);\n        }\n        .activeBtn{\n          color: var(--_10a37f-border);\n          fill: var(--_10a37f-border);\n        }\n      }\n      svg{\n        width: 20px;\n        height: 20px;\n      }\n    }\n.tagsContainer{\ndisplay: flex;\nalign-items: center;\ngap: 10px;\nwidth: 100%;\noverflow-x: auto;\n  .tag{\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    span{\n      min-width: 60px;\n    }\n  }\n}\n  }\n\n}\n\n  .parametersCounter {\n    margin: 10px 0;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    .icon {\n      height: 10px;\n      width: 10px;\n      -webkit-transition: all 300ms;\n      transform: rotate(0deg);\n      -webkit-transform: rotate(0deg);\n      -moz-transform: rotate(0deg);\n      -ms-transform: rotate(0deg);\n      -o-transform: rotate(0deg);\n    }\n    .rotated {\n      transform: rotate(180deg);\n      -webkit-transform: rotate(180deg);\n      -moz-transform: rotate(180deg);\n      -ms-transform: rotate(180deg);\n      -o-transform: rotate(180deg);\n    }\n  }\n\n  .parameter {\n    display: flex;\n    gap: 10px;\n    div {\n      flex: 1;\n    }\n  }\n  .parametersContainer {\n    transition: all 300ms;\n    -webkit-transition: all 300ms;\n    -moz-transition: all 300ms;\n    -ms-transition: all 300ms;\n    -o-transition: all 300ms;\n    overflow: hidden;\n    interpolate-size: allow-keywords;\n  }\n}\n\n.defaultPhoneNumber{\n  width: 100%;\n  color: var(--_10a37f-background);\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.headerPhoneNumer {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n}\n\n.headerPhoneNumerPopup{\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  p{\n    font-size: 12px;\n    margin: 0;\n  }\n}\n\n.headerPhoneNumerPopupLeft {\n  display: flex;\n  flex-direction: column;\n\n  .headerPhoneNumerPopupLeftFirstLine{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    justify-content: start;\n  }\n\n  .headerPhoneNumerPopupLeftSecondLine{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n}\n.unknown {\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--_71-color);\n}\n.phoneNumber {\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  gap: 10px;\n}\n.buttonPhoneContainer {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.phoneContainerUnknown {\n  display: flex;\n  width: 100%;\n}\n.phoneContainer {\n  width: 100%;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-direction: column;\n  .phoneRow {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n      svg{\n        height: 20px;\n        width: 20px;\n      }\n  }\n  .delete {\n    background-color: var(--dc3545-background);\n    height: 20px;\n    min-width: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    -webkit-border-radius: 50%;\n    -moz-border-radius: 50%;\n    -ms-border-radius: 50%;\n    -o-border-radius: 50%;\n    cursor: pointer;\n    .icon {\n      height: 13px;\n      width: 13px;\n    }\n  }\n}\n\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n.FlagsDropdown {\n  min-width: 150px;\n}\n\n.deleteButtonContainer{\npadding-left: 5px;\ndisplay: none;\n}\n\n.categoryButton{\n\n}\n\n\n.categoryButton:hover{\n  .deleteButtonContainer{\ndisplay: block;\n}\n\n}\n.inputPhonePopup::-webkit-outer-spin-button,\n.inputPhonePopup::-webkit-inner-spin-button {\n-webkit-appearance: none;\nmargin: 0;\n}\n.inputPhonePopup {\n  -moz-appearance: textfield;\n  margin: 0;\n  padding: 3px 2px;\n}\n\n.sectionContactPopup{\n    h3{\n    color: var(--_10a37f-background);\n    margin: 20px 0;\n  }\n   h5{\n    color: var(--_10a37f-background);\n    margin: 20px 0;\n  }\n\n  .infoLabel,.infoLabelIdentification{\n    background-color: var(--white-background);\n    padding: 10px 20px;\n    border: 1px solid var(--ececf1-border);\n    border-radius: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 50px;\n    >div{\n\n    }\n  }\n  .infoLabelIdentification{\n    gap: 10px;\n  }\n\n  p{\n    font-size: 12px;\n  }\n\n  span{\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_xHDHR`,
	"bg": `bg_cSEan`,
	"newContactContainer": `newContactContainer_eizDx`,
	"popupNewContaier": `popupNewContaier_m27ql`,
	"leftSide": `leftSide_Fnbhz`,
	"container": `container_ANOTU`,
	"inputWrapper": `inputWrapper_HkI_w`,
	"searchInput": `searchInput_GndFY`,
	"addButton": `addButton_aUdDN`,
	"table": `table_N_b2S`,
	"name": `name_zzlgG`,
	"small": `small__YMic`,
	"big": `big_kEFcT`,
	"actions": `actions_HDAjd`,
	"transacciones": `transacciones_XgbuC`,
	"newContactForm": `newContactForm_Lb0BA`,
	"row": `row_Fm5It`,
	"plan": `plan_JHYer`,
	"inputContainer": `inputContainer_ObXEW`,
	"input": `input_IR1es`,
	"icon": `icon_vrqFV`,
	"phoneNumber": `phoneNumber_OSj8t`,
	"btnOptionsContainer": `btnOptionsContainer_WfFTg`,
	"subHeader": `subHeader_rP4VW`,
	"edit": `edit_fJk3O`,
	"scaleUp": `scaleUp_WiCsI`,
	"sectionContact": `sectionContact_yynvR`,
	"infoLabel": `infoLabel_K53bM`,
	"infoLabelIdentification": `infoLabelIdentification_P3JKp`,
	"containerNewContactForm": `containerNewContactForm_1Grx1`,
	"typeContact": `typeContact_BXLz_`,
	"selected": `selected_TTPmL`,
	"button": `button_WcZ7w`,
	"detailsBill": `detailsBill_aTHU9`,
	"optionsDetailsBill": `optionsDetailsBill_InNAN`,
	"payMethodInfoBill": `payMethodInfoBill_kLvvx`,
	"infoBillContainer": `infoBillContainer_TLswX`,
	"info": `info_ZMw6i`,
	"editPencilContainer": `editPencilContainer_QSB3c`,
	"billingDetailsContainer": `billingDetailsContainer_btxGx`,
	"infoBill": `infoBill_DiMCm`,
	"defaultAddress": `defaultAddress_VliGx`,
	"payMethodContainer": `payMethodContainer_nbi4q`,
	"payInfo": `payInfo_fDQuf`,
	"defaultBank": `defaultBank_sg9zh`,
	"delete": `delete_oPa0T`,
	"contactinfo": `contactinfo_lAAcy`,
	"fileInfo": `fileInfo_d646b`,
	"columnRightContactInfo": `columnRightContactInfo_E9Pri`,
	"btnContactInfoContainer": `btnContactInfoContainer_ahjvs`,
	"activeBtn": `activeBtn_OKy65`,
	"tagsContainer": `tagsContainer_WjGGs`,
	"tag": `tag__ziDP`,
	"parametersCounter": `parametersCounter_X44ty`,
	"rotated": `rotated_hf8C4`,
	"parameter": `parameter_eQP_z`,
	"parametersContainer": `parametersContainer_Kmzlt`,
	"defaultPhoneNumber": `defaultPhoneNumber_p_oYG`,
	"headerPhoneNumer": `headerPhoneNumer_XwFY_`,
	"headerPhoneNumerPopup": `headerPhoneNumerPopup_u9E_c`,
	"headerPhoneNumerPopupLeft": `headerPhoneNumerPopupLeft_J_64M`,
	"headerPhoneNumerPopupLeftFirstLine": `headerPhoneNumerPopupLeftFirstLine_Y3aGL`,
	"headerPhoneNumerPopupLeftSecondLine": `headerPhoneNumerPopupLeftSecondLine_z8pop`,
	"unknown": `unknown_TVA9x`,
	"buttonPhoneContainer": `buttonPhoneContainer_SfPOR`,
	"phoneContainerUnknown": `phoneContainerUnknown_qKD5H`,
	"phoneContainer": `phoneContainer__k8JC`,
	"phoneRow": `phoneRow_aQ5V0`,
	"searchIconsWrappers": `searchIconsWrappers_KkgS2`,
	"FlagsDropdown": `FlagsDropdown_lBMVh`,
	"deleteButtonContainer": `deleteButtonContainer_j5Nak`,
	"categoryButton": `categoryButton_Vg1US`,
	"inputPhonePopup": `inputPhonePopup_lF3P7`,
	"sectionContactPopup": `sectionContactPopup_qT6Pz`
};
export default ___CSS_LOADER_EXPORT___;
